import { fetcher } from '@commenda/utils';

export const deleteBillingSkuDependency = async (
  skuId: string,
  dependencyId: string
) => {
  const response = await fetcher(
    `commenda-billing/catalog/skus/${skuId}/dependencies/${dependencyId}`,
    {
      method: 'DELETE',
    }
  );

  return response;
};
